import { AwClientInterface } from "etl/core"
import { axiosBaseQuery } from "./aw-axios-instance"
import { AwApiTarget, HttpVerb } from "etl/types"

export const awAxiosClient: AwClientInterface = {
	/************************************************************\
					ALL ABOUT LOGIN AND PROFILE
	\************************************************************/
	async getProfile() {
		return await axiosBaseQuery({
			url: AwApiTarget.USERS_API + "/me",
			method: HttpVerb.GET,
		})
	},

	async refreshToken(awAuthTokenRefresh) {
		return await axiosBaseQuery({
			url: AwApiTarget.REFRESH_TOKEN,
			method: HttpVerb.POST,
			data: {
				refresh_token: awAuthTokenRefresh,
			},
		});
	},
}

export default awAxiosClient
